import React from 'react';
import {NavLink, useNavigate} from "react-router-dom";
import {LuLayoutDashboard} from "react-icons/lu";
import {FaCubes} from "react-icons/fa";
import {IoGitPullRequestOutline} from "react-icons/io5";
import {GrDocumentExcel, GrDocumentUpdate, GrReturn} from "react-icons/gr";
import {ImList2, ImUsers} from "react-icons/im";
import {
    TbBrandApple,
    TbCube,
    TbCubePlus, TbCubeUnfolded,
    TbDeviceIpadHorizontalStar,
    TbShoppingBagSearch,
    TbStarsFilled
} from "react-icons/tb";
import {toast} from "react-toastify";
import {AiOutlineBarcode} from "react-icons/ai";
import {RiFileExcel2Line} from "react-icons/ri";
import {PiMicrosoftExcelLogoBold} from "react-icons/pi";

const Navbar = (props) => {
    const navigate = useNavigate();

    const [permissions, setPermissions] = React.useState([]);

    React.useEffect(() => {
        const thePermissions = window.localStorage.getItem("cpr");

        if (!thePermissions) {
            navigate('/');
        }
        else {

            const jPermissions = JSON.parse(thePermissions)
            setPermissions(jPermissions)

            if(jPermissions[props.page] !== 1 && props.public !== "1") {
                toast.error('دسترسی غیر مجاز');
                setTimeout (() => {
                    window.history.back()
                },1000)
            }
        }
    }, [navigate,props]);
    return (
        <React.Fragment>
            <aside id="sidebar" className="sidebar rtl">

                <ul className="sidebar-nav" id="sidebar-nav">

                    {
                        permissions.dashboard > 0 &&

                    <li className="nav-item">
                        <NavLink to='/home'
                                 className={props.page === 'dashboard' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <LuLayoutDashboard className='ms-2 nav-icon'/>
                            <span>
                            داشبورد
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.batteries > 0 &&
                    <li className="nav-item">
                        <NavLink to='/batteries'
                                 className={props.page === 'batteries' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <FaCubes className='ms-2 nav-icon'/>
                            <span>
                                گزارش باتری ها
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.status > 0 &&
                    <li className="nav-item">
                        <NavLink to='/production'
                                 className={props.page === 'status' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <IoGitPullRequestOutline className='ms-2 nav-icon'/>
                            <span>
                                گزارش وضعیت ها
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.battery > 0 &&
                    <li className="nav-item">
                        <NavLink to='/product/0'
                                 className={props.page === 'battery' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <TbCube className='ms-2 nav-icon'/>
                            <span>
                               گزارش یک باتری
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.pallet > 0 &&
                    <li className="nav-item">
                        <NavLink to='/pallet/0'
                                 className={props.page === 'pallet' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <TbCubeUnfolded className='ms-2 nav-icon'/>
                            <span>
                               گزارش یک پالت
                            </span>
                        </NavLink>
                    </li>
                    }
                    {
                        permissions.excel > 0 &&
                    <li className="nav-item">
                        <NavLink to='/product-excel'
                                 className={props.page === 'excel' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <PiMicrosoftExcelLogoBold className='ms-2 nav-icon'/>
                            <span>
                               گزارش فایل اکسل
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.update > 0 &&
                    <li className="nav-item">
                        <NavLink to='/batch-edit'
                                 className={props.page === 'update' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <GrDocumentUpdate className='ms-2 nav-icon'/>
                            <span>
                                به روز رسانی باتری ها
                            </span>
                        </NavLink>
                    </li>

                    }

                    {
                        permissions.batchreturn > 0 &&
                    <li className="nav-item">
                        <NavLink to='/batch-return'
                                 className={props.page === 'batchreturn' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <GrDocumentExcel className='ms-2 nav-icon'/>
                            <span>
                               مرجوعی با فایل اکسل
                            </span>
                        </NavLink>
                    </li>

                    }

                    {
                        permissions.createreturn > 0 &&
                    <li className="nav-item">
                        <NavLink to='/create-return'
                                 className={props.page === 'createreturn' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <GrReturn className='ms-2 nav-icon'/>
                            <span>
                                ثبت مرجوعی از طرف نماینده
                            </span>
                        </NavLink>
                    </li>

                    }
                    {
                        permissions.upsorders > 0 &&
                    <li className="nav-item">
                        <NavLink to='/return-requests'
                                 className={props.page === 'upsorders' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <GrReturn className='ms-2 nav-icon'/>
                            <span>

                                ثبت مرجوعی
                                UPS
                            </span>
                        </NavLink>
                    </li>

                    }

                    {
                        permissions.productionExcel > 0 &&
                    <li className="nav-item">
                        <NavLink to='/production-excel-report'
                                 className={props.page === 'productionExcel' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <RiFileExcel2Line  className='ms-2 nav-icon'/>
                            <span>
                              گزارش خط تولید با اکسل
                            </span>
                        </NavLink>
                    </li>

                    }


                    {
                        permissions.sbatteries > 0 &&
                        <li className="nav-item">
                            <NavLink to='/sbatteries'
                                     className={props.page === 'sbatteries' ? "nav-link" : "nav-link collapsed"}
                                     role="button"
                            >
                                <TbStarsFilled className='ms-2 nav-icon'/>
                                <span>
                                گزارش باتری های ویژه
                            </span>
                            </NavLink>
                        </li>
                    }
                    {
                        permissions.special > 0 &&
                        <li className="nav-item">
                            <NavLink to='/special'
                                     className={props.page === 'special' ? "nav-link" : "nav-link collapsed"}
                                     role="button"
                            >
                                <TbDeviceIpadHorizontalStar className='ms-2 nav-icon'/>
                                <span>
                               گزارش باتری ویژه با اکسل
                            </span>
                            </NavLink>
                        </li>
                    }
                    {
                        permissions.productionReport > 0 &&
                        <li className="nav-item">
                            <NavLink to='/productionReport'
                                     className={props.page === 'productionReport' ? "nav-link" : "nav-link collapsed"}
                                     role="button"
                            >
                                <TbCubePlus className='ms-2 nav-icon'/>
                                <span>
                            گزارش اکسل خط تولید باتری
                            </span>
                            </NavLink>
                        </li>
                    }

                    {
                        permissions.tracking > 0 &&
                    <li className="nav-item">
                        <NavLink to='/tracking'
                                 className={props.page === 'tracking' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <AiOutlineBarcode  className='ms-2 nav-icon'/>
                            <span>
                               بارگزاری کد رهگیری کالا
                            </span>
                        </NavLink>
                    </li>

                    }
                    <li className="nav-item">
                        <hr/>
                    </li>


                    {
                        permissions.agents > 0 &&
                    <li className="nav-item">
                        <NavLink to='/agents'
                                 className={props.page === 'agents' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <ImUsers className='ms-2 nav-icon'/>
                            <span>
                              گزارش عاملین فروش نمایندگان
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.orders > 0 &&
                    <li className="nav-item">
                        <NavLink to='/orders'
                                 className={props.page === 'orders' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <ImList2 className='ms-2 nav-icon'/>
                            <span>
                            گزارش سفارش های نمایندگان
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.returns > 0 &&
                    <li className="nav-item">
                        <NavLink to='/return-orders'
                                 className={props.page === 'returns' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <ImList2 className='ms-2 nav-icon'/>
                            <span>
                            گزارش سفارش های مرجوعی
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.sborders > 0 &&
                        <li className="nav-item">
                            <NavLink to='/sb-orders'
                                     className={props.page === 'sborders' ? "nav-link" : "nav-link collapsed"}
                                     role="button"
                            >
                                <ImList2 className='ms-2 nav-icon'/>
                                <span>
                            گزارش  برگشت از فروش
                            </span>
                            </NavLink>
                        </li>
                    }

                    <li className="nav-item">
                        <hr/>
                    </li>

                    {
                        permissions.brands > 0 &&
                    <li className="nav-item">
                        <NavLink to='/brand'
                                 className={props.page === 'brands' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <TbBrandApple className='ms-2 nav-icon'/>
                            <span>
                               فروش مرجوعی (برند)
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.monthBrands > 0 &&
                    <li className="nav-item">
                        <NavLink to='/brand-month'
                                 className={props.page === 'monthBrands' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <TbBrandApple className='ms-2 nav-icon'/>
                            <span>
                               فروش مرجوعی (برند-ماهانه)
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.vendors > 0 &&
                    <li className="nav-item">
                        <NavLink to='/vendor'
                                 className={props.page === 'vendors' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <TbShoppingBagSearch className='ms-2 nav-icon'/>
                            <span>
                               فروش مرجوعی (نماینده)
                            </span>
                        </NavLink>
                    </li>
                    }

                    {
                        permissions.monthVendors > 0 &&
                    <li className="nav-item">
                        <NavLink to='/vendor-month'
                                 className={props.page === 'monthVendors' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <TbShoppingBagSearch className='ms-2 nav-icon'/>
                            <span>
                               فروش مرجوعی (نماینده-ماهانه)
                            </span>
                        </NavLink>
                    </li>
                    }

                </ul>

            </aside>
        </React.Fragment>
    );
};

export default Navbar;
